<script>
import NameComponent from "./NameComponent.vue";
import ImageComponent from "./ImageComponent.vue";
import PriceComponent from "./PriceComponent.vue";
import ActionComponent from "./ActionComponent.vue";
import PromptComponent from "./PromptComponent.vue";

export default {
  name: "ObjectsComponent",
  components: {
    NameComponent,
    ImageComponent,
    PriceComponent,
    ActionComponent,
    PromptComponent
  },
  props: {
    objects: {
      type: Array,
      required: true
    },
    reportType: {
      type: Number,
      required: true
    },
    paperReportPrice: {
      type: Number,
      required: true
    },
    deleteCartItemHandler: {
      type: Function,
      required: true
    }
  }
}
</script>

<template>
  <div class="services">
    <div v-for="(object, objectIndex) in objects" :key="object.id" class="service-item">
      <div class="service-item-header">
        <name-component
          :name="object.name"
          :index="objectIndex+1"
          :page-alias="object.page.alias"
        />
      </div>
      <div class="service-item-body">
        <image-component :image-src="object.image" />
        <price-component
          :paper-report-price="paperReportPrice"
          :report-type="reportType"
          :object-price-sale="object.priceSale"
          :object-price="object.price"
        />
        <action-component
          :local-storage-index="object.dbIndex"
          :delete-cart-item-handler="deleteCartItemHandler"
        />
      </div>
      <div class="service-item-footer">
        <prompt-component :document-prompt="object.prompt" />
      </div>
    </div>
  </div>
</template>

<style scoped>

.services .service-item {
  margin: 10px 0;
  padding: 10px;
}

.services .service-item:nth-child(odd) {
  background-color: #f5f5f5;
}

.services .service-item:nth-child(even) {
  background-color: #f5f5f5;
}

.services .service-item-body {
  margin-bottom: 5px;
}

</style>
